import { QRCodeSVG as QRCode } from "qrcode.react";

interface PubQRProps {
  width?: string;
  height?: string;
  qrValue: string;
}
const PubQR = ({ width = "98%", height = "98%", qrValue }: PubQRProps) => {
  return (
    <div
      style={{
        width: width,
        height: height,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <QRCode
        value={qrValue}
        width="98%"
        height="98%"
        level="L"
        includeMargin={true}
        bgColor="#ffffff"
        fgColor="#000000"
        radius={8}
        // imageSettings={{
        //   src: "./image-web/logo.png",
        //   x: undefined,
        //   y: undefined,
        //   height: 20,
        //   width: 20,
        //   excavate: true,
        // }}
      />
    </div>
  );
};

export default PubQR;
